import api from '../../utils/api';

export const seguridadAPI = {
  dashboard: (range = '24h') => api.get(`/admin/seguridad/dashboard?range=${range}`),

  blocks: (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') q.append(k, v);
    });
    return api.get(`/admin/seguridad/blocks?${q}`);
  },
  unblock: (scope, ip, email) =>
    api.post('/admin/seguridad/unblock', { scope, ip, email }),

  trustedIPs: () => api.get('/admin/seguridad/trusted-ips'),
  createTrustedIP: (ip_or_cidr, label) =>
    api.post('/admin/seguridad/trusted-ips', { ip_or_cidr, label }),
  updateTrustedIP: (id, patch) =>
    api.put(`/admin/seguridad/trusted-ips/${id}`, patch),
  deleteTrustedIP: (id) =>
    api.delete(`/admin/seguridad/trusted-ips/${id}`),

  ackSpraying: (eventId) =>
    api.post(`/admin/seguridad/spraying/${eventId}/ack`),

  purge: (days = 30) => api.post(`/admin/seguridad/purge?days=${days}`),
};
